export default __webpack_public_path__ + "static/media/editButton.d1dfc1d6.svg";